import {
  getTargetActivityById
} from "../../data/planning/targetActivityCatalog";

import {
  getAdditionalGroupActivityById
} from "../../data/planning/additionalGroupActivityCatalog";

import {
  getMebbisDisplayCode
} from "../../data/planning/mebbisCodeMap";

import {
  getExactMebbisCode
} from "../../data/planning/mebbisExactCodeMap";

import {
  getActivityTypeById
} from "../../data/planning/activityTypeCatalog";

import {
  getDefaultActivityTypeForAdditionalCategory
} from "../../data/planning/activityTypeCatalog";


const SAFE_ADDITIONAL_GENERIC_CATEGORIES =
  new Set([
    "orientation_monitoring",
    "group_counseling",
    "psychosocial_intervention",
    "consultancy_other",
    "program_management",
    "cooperation_meetings",
    "cooperation_activities",
    "professional_development"
  ]);


const getTargetMebbisCategory = activity => {

  if (!activity) {
    return null;
  }

  if (activity.audience === "student") {

    if (
      activity.developmentArea ===
      "social_emotional"
    ) {
      return "student_social_emotional";
    }

    if (
      activity.developmentArea ===
      "academic"
    ) {
      return "student_academic";
    }

    if (
      activity.developmentArea ===
      "career"
    ) {
      return "student_career";
    }
  }

  if (activity.audience === "parent") {
    return "parent_support";
  }

  if (activity.audience === "teacher") {
    return "teacher_support";
  }

  return null;
};


export const resolveTargetMebbisCode =
  activity => {

    if (!activity) {
      return null;
    }

    const exactCode =
      getExactMebbisCode({
        category:
          getTargetMebbisCategory(
            activity
          ),
        officialLabel:
          activity.officialLabel
      });

    if (exactCode) {
      return exactCode;
    }

    return (
      getMebbisDisplayCode(
        activity
      ) ||
      null
    );
  };


export const resolveAdditionalMebbisCode =
  activity => {

    if (!activity) {
      return null;
    }

    const exactCode =
      getExactMebbisCode({
        category:
          activity.category,
        officialLabel:
          activity.officialLabel
      });

    if (exactCode) {
      return exactCode;
    }

    if (
      !SAFE_ADDITIONAL_GENERIC_CATEGORIES
        .has(activity.category)
    ) {
      return null;
    }

    return (
      getMebbisDisplayCode(
        activity
      ) ||
      null
    );
  };


export const buildTargetActivityRows = ({
  selectedActivities = {},
  selectedTargets = [],
  selectedActivityLevels = {},
  selectedActivityTypes = {}
} = {}) => {

  const rows = [];

  selectedTargets.forEach(target => {

    if (!target?.id) {
      return;
    }

    [
      "student",
      "parent",
      "teacher"
    ].forEach(audience => {

      const activityIds =
        selectedActivities
          ?.[target.type]
          ?.[audience] ||
        [];

      activityIds.forEach(activityId => {

        const activity =
          getTargetActivityById(
            activityId
          );

        if (!activity) {
          return;
        }

       const activitySelectionKey =
  `${target.type}__${audience}__${activity.id}`;


const rawActivityLevel =
  Number(
    selectedActivityLevels[
      activitySelectionKey
    ]
  );


const activityLevel =
  [1, 2, 3].includes(
    rawActivityLevel
  )
    ? rawActivityLevel
    : null;


const activityTypeId =
  selectedActivityTypes[
    activitySelectionKey
  ] ||
  null;


const selectedActivityType =
  activityTypeId
    ? getActivityTypeById(
        activityTypeId
      )
    : null;


/*
 * Faaliyet türünün seçilen düzeyle
 * gerçekten eşleştiğini doğrula.
 *
 * Stale localStorage veya ilerideki
 * veri değişiklikleri yanlış türün
 * plana girmesine neden olamaz.
 */
const activityType =
  (
    selectedActivityType &&
    activityLevel &&
    selectedActivityType.level ===
      activityLevel
  )
    ? selectedActivityType
    : null;       
  
        rows.push({

          id:
            `target_${target.type}_${audience}_${activity.id}`,

          activityId:
            activity.id,

          officialLabel:
            activity.officialLabel,

          mebbisCode:
            resolveTargetMebbisCode(
              activity
            ),

          sourceType:
            "target",

          sourceCatalog:
            "targetActivityCatalog",

          audience,

          targetType:
            target.type,

          targetId:
            target.id,

          targetLabel:
            target.label,

          developmentArea:
  activity.developmentArea ||
  target.developmentArea ||
  null,

activityLevel,

activityTypeId,

activityTypeLabel:
  activityType
    ?.officialLabel ||
  null,

activityTypeShortLabel:
  activityType
    ?.shortLabel ||
  null,

workMode:
  activity.workMode ||
  "group",

          timingRule: {
            type: "balanced"
          },

          selectionMode:
            "user",

          locked:
            false,

          selected:
            true

        });
      });
    });
  });

  return rows;
};



// =========================================================
// OTOMATİK ROBOT - HEDEF FAALİYETİ SLOT SATIRLARI
// =========================================================
//
// Manuel Robot:
//   activityId bazlı seçim yapısını kullanır.
//
// Otomatik Robot:
//   slotId bazlı çalışır.
//
// Böylece aynı resmî faaliyet konusu:
//
//   required_1
//   required_2
//
// gibi farklı slotlarda, farklı resmî faaliyet türleriyle
// birden fazla plan satırına dönüşebilir.
//
// Manuel Robot yapısına dokunulmaz.
// =========================================================

export const buildAutoTargetActivityRows = ({
  autoActivitySlots = []
} = {}) => {

  const rows = [];

  const usedRowIds =
    new Set();


  (
    Array.isArray(
      autoActivitySlots
    )
      ? autoActivitySlots
      : []
  ).forEach((slot, index) => {

    if (
      !slot?.slotId ||
      !slot?.targetType ||
      !slot?.targetId ||
      !slot?.audience ||
      !slot?.activityId
    ) {
      return;
    }


    const activity =
      getTargetActivityById(
        slot.activityId
      );


    if (!activity) {
      return;
    }


    /*
     * Hedef kitle güvenliği.
     *
     * Öğrenci faaliyeti veli/öğretmen
     * slotuna yanlışlıkla giremez.
     */
    if (
      activity.audience !==
        slot.audience
    ) {
      return;
    }


    /*
     * Öğrenci faaliyetlerinde gelişim
     * alanı da hedef ile uyumlu olmalı.
     */
    if (
      slot.audience === "student" &&
      slot.developmentArea &&
      activity.developmentArea !==
        slot.developmentArea
    ) {
      return;
    }


    const rawActivityLevel =
      Number(
        slot.activityLevel
      );


    const activityLevel =
      [1, 2, 3].includes(
        rawActivityLevel
      )
        ? rawActivityLevel
        : null;


    const selectedActivityType =
      slot.activityTypeId
        ? getActivityTypeById(
            slot.activityTypeId
          )
        : null;


    /*
     * Otomatik Robot yarım / geçersiz
     * faaliyet türü üretmez.
     *
     * Düzey 1 slotu yalnız Düzey 1
     * faaliyet türüyle eşleşebilir.
     */
    const activityType =
      (
        selectedActivityType &&
        activityLevel &&
        selectedActivityType.level ===
          activityLevel
      )
        ? selectedActivityType
        : null;


    if (
      !activityLevel ||
      !activityType
    ) {
      return;
    }


    /*
     * Satır kimliği activityId üzerinden değil,
     * SLOT üzerinden oluşturulur.
     *
     * Böylece aynı activityId:
     *
     * required_1
     * required_2
     *
     * şeklinde iki ayrı satır olabilir.
     */
    const rowId =
      `auto_target_${slot.targetType}_${slot.audience}_${slot.slotId}`;


    /*
     * Aynı slot iki kez üretilemez.
     */
    if (
      usedRowIds.has(
        rowId
      )
    ) {
      return;
    }


    usedRowIds.add(
      rowId
    );


    rows.push({

      id:
        rowId,

      autoSlotId:
        slot.slotId,

      autoGenerated:
        true,

      activityId:
        activity.id,

      officialLabel:
        activity.officialLabel,

      mebbisCode:
        resolveTargetMebbisCode(
          activity
        ),

      sourceType:
        "target",

      sourceCatalog:
        "targetActivityCatalog",

      selectionSource:
        "auto_robot",

      audience:
        slot.audience,

      targetType:
        slot.targetType,

      targetId:
        slot.targetId,

      targetLabel:
        slot.targetLabel ||
        null,

      developmentArea:
        activity.developmentArea ||
        slot.developmentArea ||
        null,

      activityLevel,

      activityTypeId:
        activityType.id,

      activityTypeLabel:
        activityType.officialLabel,

      activityTypeShortLabel:
        activityType.shortLabel ||
        null,

      activityTypeSource:
        "auto_verified",

      workMode:
        activity.workMode ||
        "group",

      timingRule: {
        type: "balanced"
      },

      selectionMode:
        "auto",

      locked:
        false,

      selected:
        true,

      autoOrder:
        Number.isFinite(
          Number(slot.order)
        )
          ? Number(slot.order)
          : index

    });

  });


  return rows;
};


export const buildAdditionalGroupActivityRows = ({
  selectedAdditionalActivities = [],
  selectedAdditionalActivityTypes = {}
} = {}) => {

  return selectedAdditionalActivities
    .map(activityId => {

      const activity =
        getAdditionalGroupActivityById(
          activityId
        );

      if (!activity) {
        return null;
      }

      const defaultActivityType =
  getDefaultActivityTypeForAdditionalCategory(
    activity.category
  );


const manualActivityTypeId =
  selectedAdditionalActivityTypes[
    activity.id
  ] ||
  null;


const manualActivityType =
  manualActivityTypeId
    ? getActivityTypeById(
        manualActivityTypeId
      )
    : null;


const resolvedActivityType =
  defaultActivityType ||
  manualActivityType;


      return {

        id:
          `additional_${activity.id}`,

        activityId:
          activity.id,

        officialLabel:
          activity.officialLabel,

        mebbisCode:
          resolveAdditionalMebbisCode(
            activity
          ),

        sourceType:
          "additional_group",

        sourceCatalog:
          "additionalGroupActivityCatalog",

        audience:
          activity.audience ||
          null,

        targetType:
          null,

        targetId:
          null,

        targetLabel:
          null,

       developmentArea:
  activity.developmentArea ||
  null,

activityLevel:
  null,

activityTypeId:
  resolvedActivityType
    ?.id ||
  null,

activityTypeLabel:
  resolvedActivityType
    ?.officialLabel ||
  null,

activityTypeShortLabel:
  resolvedActivityType
    ?.shortLabel ||
  null,

activityTypeSource:
  defaultActivityType
    ? "verified_default"
    : manualActivityType
      ? "user_selected"
      : null,

workMode:
  activity.workMode ||
  "group",

        serviceDomain:
          activity.serviceDomain ||
          null,

        category:
          activity.category ||
          null,

        categoryLabel:
          activity.categoryLabel ||
          null,

        schoolLevel:
          activity.schoolLevel ||
          null,

        timingRule: {
          type: "balanced"
        },

        selectionMode:
          "user",

        locked:
          false,

        selected:
          true

      };

    })
    .filter(Boolean);
};


export const buildSelectedActivityRows = ({
  selectedActivities = {},
  selectedAdditionalActivities = [],
  selectedTargets = [],
  selectedActivityLevels = {},
  selectedActivityTypes = {},
  selectedAdditionalActivityTypes = {}
} = {}) => {

  const targetRows =
  buildTargetActivityRows({
    selectedActivities,
    selectedTargets,
    selectedActivityLevels,
    selectedActivityTypes
  });

  const additionalRows =
  buildAdditionalGroupActivityRows({
    selectedAdditionalActivities,
    selectedAdditionalActivityTypes
  });

  return {

    targetRows,

    additionalRows,

    allRows: [
      ...targetRows,
      ...additionalRows
    ],

    counts: {
      target:
        targetRows.length,
      additional:
        additionalRows.length,
      total:
        targetRows.length +
        additionalRows.length
    }

  };
};